/** Analyses : sans le droit, l'API refuserait de toute façon chaque chiffre. */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const AnalyticsPage = lazy(() => import('./AnalyticsPage.js').then((m) => ({ default: m.AnalyticsPage })));

export const analyticsRoutes: AppRoute[] = [
  { path: '/analyses', element: <AnalyticsPage />, gate: { anyOf: ['analytics.view'] } },
];
